var styleDataHash = '70b86e96';  
export const injectCss = (() => {
  var css = `._3poGS{min-height:630px;--wds-tabs-padding-vertical-small:18px;--wds-tabs-padding-horizontal-small:12px}.IzRSz{--wds-side-panel-floating-header-padding-left:7px}.Sm97f{--wds-form-field-label-gap-small:9px;--wds-field-set-label-gap-small:6px}`;
  var isTest = typeof process !== 'undefined' && process.env && process.env['NODE_ENV'] === 'test';

  if (isTest || !css || typeof document === 'undefined') { return; }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.setAttribute('data-ricos-style-hash', styleDataHash);
  style.type = 'text/css';

  head.appendChild(style);

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});

injectCss();



export default {
  "modal": "_3poGS",
  "header": "IzRSz",
  "content": "Sm97f"
};